<template>
  <v-card class="session__container">
    <ChooseLanguage :positionAbsolute="true" />
    <div class="session__content">
      <div>
        <v-img
          src="@/static/brand_logo.svg"
          class="mx-auto session__logo"
          aspect-ratio
          width="300"
        >
        </v-img>
      </div>
      <h2 class="mb-3 text-center session__title">
        {{ $t("message.common.resetPassword") }}
      </h2>
      <template v-if="!resetConfirmMessage">
        <p class="text-center session__description">
          {{ $t("message.session.reset.description") }}.
        </p>
        <v-form v-model="valid" @submit.prevent="submit" class="mb-4">
          <v-text-field
            :label="newPasswordLabel"
            v-model="newPassword"
            type="password"
            v-validate="'required|min:9'"
            :error-messages="errors.collect(newPasswordLabel)"
            :data-vv-name="newPasswordLabel"
            required
          ></v-text-field>
          <v-text-field
            :label="confirmPasswordLabel"
            v-model="confirmPassword"
            type="password"
            v-validate="'required|min:9'"
            :error-messages="errors.collect(confirmPasswordLabel)"
            :data-vv-name="confirmPasswordLabel"
            required
          ></v-text-field>
          <v-btn large type="submit" block color="primary">{{
            $t("message.common.resetPassword")
          }}</v-btn>
        </v-form>
      </template>
      <template v-else>
        <p class="text-center session__description mb-4">
          {{ resetConfirmMessage }}
        </p>
        <div class="text-center">
          <router-link :to="{ name: 'session-login' }">{{
            $t("message.common.backToSignIn")
          }}</router-link>
        </div>
      </template>
    </div>
  </v-card>
</template>

<script>
import ChooseLanguage from "@/components/AppBar/ChooseLanguage.vue";
import serviceHandler from "@/helpers/handlers/service";
import userService from "@/services/users";

export default {
  name: "SessionResetPassword",
  data() {
    return {
      valid: false,
      newPassword: "",
      confirmPassword: "",
      newPasswordLabel: this.$t("message.common.password"),
      confirmPasswordLabel: this.$t("message.common.confirmPassword"),
      resetConfirmMessage: ""
    };
  },
  components: { ChooseLanguage },
  beforeRouteEnter(to, from, next) {
    to.params.token && to.params.uid ? next() : next({ name: "session/login" });
  },
  methods: {
    // TODO: Reset method
    async submit() {
      if (this.valid) {
        const body = {
          new_password1: this.newPassword,
          new_password2: this.confirmPassword,
          uid: this.$route.params.uid,
          token: this.$route.params.token
        };
        const resetConfirmMessage = await serviceHandler(
          userService.confirmResetPassword(body)
        );
        if (resetConfirmMessage) {
          this.resetConfirmMessage = resetConfirmMessage.detail;
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
